import { render, staticRenderFns } from "./FreePicklsPopup.vue?vue&type=template&id=3e407835&scoped=true&"
import script from "./FreePicklsPopup.vue?vue&type=script&lang=ts&"
export * from "./FreePicklsPopup.vue?vue&type=script&lang=ts&"
import style0 from "./FreePicklsPopup.vue?vue&type=style&index=0&id=3e407835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e407835",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e407835')) {
      api.createRecord('3e407835', component.options)
    } else {
      api.reload('3e407835', component.options)
    }
    module.hot.accept("./FreePicklsPopup.vue?vue&type=template&id=3e407835&scoped=true&", function () {
      api.rerender('3e407835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/FreePicklsPopup.vue"
export default component.exports